import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Stack,
  Typography,
  CircularProgress,
} from "@mui/material";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";
import toast from "react-hot-toast";
import { URL } from "../config";

const ExtraAdvertisementModal = ({ onClose, ad }) => {
  const [imageFile, setImageFile] = useState(null);
  const [preview, setPreview] = useState("");
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    if (ad?.extraAdvertisementImage) {
      setPreview(`${URL}${ad.extraAdvertisementImage}`);
    }
  }, [ad]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (!file?.type.startsWith("image/")) {
      toast.error("Only image files allowed!");
      return;
    }

    setImageFile(file);

  
    setPreview(window.URL.createObjectURL(file));
  };

  const handleSubmit = async () => {
    if (!imageFile && !ad) {
      toast.error("Please select image");
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      if (imageFile) {
        formData.append("extraAdvertisementImage", imageFile);
      }

      if (ad) {
    
        await axios.patch(
          `${URL}/extraadvertisements/${ad.extraAdvertisementId}`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        toast.success("Extra Advertisement updated");
      } else {
        
        await axios.post(`${URL}/extraadvertisements`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        toast.success("Extra Advertisement added");
      }

      onClose();
    } catch (err) {
      console.error(err);
      toast.error("Upload failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        bgcolor: "rgba(0,0,0,0.6)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1300,
      }}
    >
      <Box sx={{ width: 400, bgcolor: "#fff", p: 3, borderRadius: 2 }}>
        <Typography
          variant="h6"
          sx={{ textAlign: "center", color: "#184459", mb: 2 }}
        >
          {ad ? "Edit Extra Advertisement" : "Add Extra Advertisement"}
        </Typography>

        <Stack spacing={2}>
          {/* Upload */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              p: 1.5,
              border: "1px solid #c4c4c4",
              borderRadius: 2,
              bgcolor: "#f9f9f9",
            }}
          >
            <Button component="label" startIcon={<UploadOutlined />}>
              Select Image
              <input
                hidden
                type="file"
                accept="image/*"
                onChange={handleImageChange}
              />
            </Button>

            {preview && (
              <Box
                sx={{
                  width: 50,
                  height: 50,
                  borderRadius: 1,
                  overflow: "hidden",
                  border: "1px solid #ccc",
                }}
              >
                <img
                  src={preview}
                  alt="preview"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </Box>
            )}
          </Box>

          {/* Buttons */}
          <Stack direction="row" justifyContent="flex-end" spacing={1}>
            <Button
              variant="contained"
              sx={{ bgcolor: "#184459" }}
              onClick={handleSubmit}
              startIcon={loading && <CircularProgress size={18} />}
            >
              {loading ? "Saving..." : ad ? "Update" : "Upload"}
            </Button>

            <Button
              variant="contained"
              sx={{ bgcolor: "#757575" }}
              onClick={onClose}
            >
              Close
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};

export default ExtraAdvertisementModal;
